import React from "react"
import Container from "./IconContainer"


const AppIcon = ({ ...props }) => (
  <Container {...props}>
    <svg
      width="14px"
      height="14px"
      viewBox="0 0 14 14"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="190701"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="2_NYT-Dashboard-D"
          transform="translate(-106.000000, -3223.000000)"
          stroke="#505050"
          strokeWidth="1.25"
        >
          <g id="Group-8" transform="translate(107.000000, 3224.000000)">
            <rect id="Rectangle-path" x="0" y="0" width="5" height="5" />
            <rect id="Rectangle-path" x="7" y="0" width="5" height="5" />
            <rect id="Rectangle-path" x="7" y="7" width="5" height="5" />
            <rect id="Rectangle-path" x="0" y="7" width="5" height="5" />
          </g>
        </g>
      </g>
    </svg>
  </Container>
)

export default AppIcon



// WEBPACK FOOTER //
// ./assets/common/components/icons/AppIcon.js